export default function BudgetAllocatedIllustration() {
  return (
<svg
      width="98"
      height="64"
      viewBox="0 0 98 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Budget Allocated Illustration</title>
      <g clipPath="url(#clip0_1647_12129)">
        <rect width="98" height="64" rx="8" fill="#131313" />
        <path
          d="M101.406 -33.271L53.498 30.6056L101.406 -3.55056V-33.271Z"
          fill="#FBFBFB"
          fillOpacity="0.08"
        />
        <path
          d="M62.813 122.43L50.3927 35.9302L86.7671 106.017L62.813 122.43Z"
          fill="#FBFBFB"
          fillOpacity="0.08"
        />
        <path
          d="M97.0118 92.2327L51.5581 35.3393L97.0118 73.3715V92.2327Z"
          fill="#FBFBFB"
          fillOpacity="0.08"
        />
        <path
          d="M5.14697 -48.3513L48.6183 32.3817L52.6108 29.2765L36.198 -66.5388L5.14697 -48.3513Z"
          fill="#FBFBFB"
          fillOpacity="0.08"
        />
        <path
          d="M112.415 48.8793L57.5614 36.5103L112.415 43.9243V48.8793Z"
          fill="#FBFBFB"
          fillOpacity="0.08"
        />
        <path
          d="M-8.06353 47.4784L51.9299 36.5103L-8.06353 42.5235V47.4784Z"
          fill="#FBFBFB"
          fillOpacity="0.08"
        />
        <path
          d="M-4.09155 85.3826L44.7475 41.8521L7.9412 95.9996L-4.09155 85.3826Z"
          fill="#FBFBFB"
          fillOpacity="0.08"
        />
        <path
          d="M-21.433 -14.4205L44.0396 32.2946H51.1176L-12.9391 -24.6836L-21.433 -14.4205Z"
          fill="#FBFBFB"
          fillOpacity="0.08"
        />
        <g filter="url(#filter0_d_1647_12129)">
          <rect
            width="25.5699"
            height="25.5699"
            rx="12.7849"
            transform="matrix(0.984808 -0.173648 0.438371 0.898794 32.6873 24.5273)"
            fill="#96FF43"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M50.5371 31.4551L54.4063 30.7808C54.7102 30.7276 55.0329 31.0127 54.9635 31.2627L54.9641 31.2629L52.4143 40.3774C52.3211 40.713 51.69 40.5929 51.6198 40.1929L50.3719 34.3653L46.5029 35.0475C46.2093 35.0993 45.8587 34.8237 45.9506 34.5429L48.4945 25.45C48.5877 25.1144 49.2185 25.2343 49.2891 25.6343L50.5371 31.4551Z"
            fill="#222222"
          />
        </g>
      </g>
      <rect
        x="0.5"
        y="0.5"
        width="97"
        height="63"
        rx="7.5"
        stroke="#FBFBFB"
        strokeOpacity="0.12"
      />
      <defs>
        <filter
          id="filter0_d_1647_12129"
          x="31.6873"
          y="20.0874"
          width="37.3905"
          height="29.4219"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1" dy="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.984314 0 0 0 0 0.984314 0 0 0 0 0.984314 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1647_12129"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1647_12129"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_1647_12129">
          <rect width="98" height="64" rx="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
